import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=12912555&"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=12912555&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports